import { useForm } from 'react-hook-form';
import { useYupValidationResolver } from '@hooks';
import { LOCATION_TYPE } from '@features/ComboLocationSelect';
import {
    SmsSchema,
    WhatsAppSchema,
    WhatsAppBusinessSchema,
    LiveChatSchema,
    FacebookSchema,
    EmailSchema,
} from '@features/ChannelsForms/schemas';
import { CHANNEL } from '@constants/channels';

const SchemaFactory = {
    [CHANNEL.SMS]: SmsSchema,
    [CHANNEL.WHATSAPP]: WhatsAppSchema,
    [CHANNEL.LIVE_CHAT]: LiveChatSchema,
    [CHANNEL.FACEBOOK]: FacebookSchema,
    [CHANNEL.INSTAGRAM]: FacebookSchema,
    [CHANNEL.EMAIL]: EmailSchema,
    [CHANNEL.WHATSAPP_BUSINESS]: WhatsAppBusinessSchema,
};

const DefaultValuesFactory = {
    [CHANNEL.SMS]: {
        name: '',
        locationId: '',
        brandId: '',
        locationType: LOCATION_TYPE.BRAND,
        brandAccess: false,
        phoneNumber: '',
        senderId: '',
        provider: 0,
        accountId: '',
        apiKey: '',
        token: '',
        login: '',
        password: '',
    },
    [CHANNEL.WHATSAPP]: {
        name: '',
        locationId: '',
        brandId: '',
        locationType: LOCATION_TYPE.BRAND,
        brandAccess: false,
        newWhatsAppAccount: false,
    },
    [CHANNEL.WHATSAPP_BUSINESS]: {
        name: '',
        locationId: '',
        brandId: '',
        locationType: LOCATION_TYPE.BRAND,
        brandAccess: false,
        phoneNumber: '',
        phoneNumberId: '',
        phoneNumberName: '',
        whatsAppBusinessId: '',
    },
    [CHANNEL.LIVE_CHAT]: {
        name: '',
        locationId: '',
        brandId: '',
        locationType: LOCATION_TYPE.BRAND,
        brandAccess: false,
        smsChannelId: '',
        emailChannelId: '',
        useDefaultEmailChannel: false,
        labels: [],
        notifyAboutMissingConversations: false,
        welcomeHeading: '',
        welcomeTagline: '',
        workingHoursEnabled: false,
        offlineMessage: '',
        workingHours: {},
        contactEmail: false,
        contactEmailRequired: false,
        contactPhone: true,
        contactPhoneRequired: true,
        contactName: true,
        contactNameRequired: true,
        locationsEnabled: false,
        locations: [],
    },
    [CHANNEL.FACEBOOK]: {
        name: '',
        locationId: '',
        id: undefined,
        saveInstagramReplies: true,
    },
    [CHANNEL.INSTAGRAM]: {
        name: '',
        locationId: '',
        id: undefined,
        saveInstagramReplies: true,
    },
    [CHANNEL.EMAIL]: {
        name: '',
        locationId: '',
        brandId: '',
        locationType: LOCATION_TYPE.BRAND,
        brandAccess: false,
        provider: 0,
        smtpHost: '',
        smtpPort: '',
        username: '',
        isSSL: true,
        email: '',
        password: '',
    },
};

export const useEditChannelsForm = type => {
    const resolver = useYupValidationResolver(SchemaFactory[type]);

    const {
        getValues,
        setValue,
        control,
        reset,
        watch,
        trigger,
        formState: { isValid, isDirty },
    } = useForm({
        mode: 'all',
        resolver,
        defaultValues: DefaultValuesFactory[type],
    });

    return {
        getValues,
        setValue,
        control,
        reset,
        watch,
        trigger,
        isValid,
        isDirty,
    };
};
